export function assertNever(value: never): never {
  throw new Error(`Unexpected value: ${value}`);
}

export function verifyNever(_: never): void {
  // do nothing
}
